import { InputFieldDef } from '../../../types/admin';

export const emptyField: InputFieldDef = { name: '', type: 'string', direction: 'in' };

export const trimOrUndefined = (value?: string) => {
  const trimmed = value?.trim();
  return trimmed || undefined;
};

export function parseOptionalJson(
  value: string,
  key: string,
  errors: Record<string, string>
): unknown | undefined {
  if (!value.trim()) return undefined;
  try {
    return JSON.parse(value);
  } catch {
    errors[key] = 'Must be valid JSON';
    return undefined;
  }
}

export function parseDefaultValue(
  value: unknown,
  type: InputFieldDef['type'],
  errors: Record<string, string>
): unknown {
  if (value === '' || value === undefined) return undefined;
  if (type === 'integer') return Number.isFinite(Number(value)) ? Math.trunc(Number(value)) : value;
  if (type === 'number') return Number.isFinite(Number(value)) ? Number(value) : value;
  if (type === 'boolean') return Boolean(value);
  if (type === 'object' || type === 'object[]') {
    if (typeof value !== 'string') return value;
    try {
      return JSON.parse(value);
    } catch {
      errors.default = 'Must be valid JSON';
      return undefined;
    }
  }
  return value;
}

export function coerceEnumValue(value: string): string | number {
  const numeric = Number(value);
  return value.trim() !== '' && Number.isFinite(numeric) ? numeric : value;
}

/** Splits pasted text like `"4s" | "6s", 8s` into enum values (quotes stripped, deduped). */
export function parseEnumInputs(items: string[]): Array<string | number> {
  const values = items
    .flatMap((item) => item.split(/[|,\n]/))
    .map((part) => part.trim().replace(/^(["'`])(.*)\1$/, '$2').trim())
    .filter((part) => part !== '')
    .map(coerceEnumValue);
  return values.filter((value, index) => values.indexOf(value) === index);
}

export function compactField(field: InputFieldDef): InputFieldDef {
  return Object.entries(field).reduce<InputFieldDef>(
    (result, [key, value]) => {
      if (value === undefined || value === '') return result;
      if (Array.isArray(value) && value.length === 0) return result;
      return { ...result, [key]: value };
    },
    { name: field.name, type: field.type }
  );
}

export const OUT_SEMANTICS = [
  'output.url',
  'output.status',
  'output.error',
  'output.jobId',
  'usage.seconds',
  'usage.imageCount',
  'usage.inputTokens',
  'usage.outputTokens',
];

export function formatValue(value: unknown): string {
  if (value === undefined) return '-';
  return typeof value === 'object' ? JSON.stringify(value) : String(value);
}
